import {type MutationTree} from 'vuex';
import LocalStorage from '../../../../library/localStorage';

const mutations: MutationTree<ModuleSchoolState> = {
    toggle(state, payload)
    {
        const index = state.entitiesClosed.indexOf(payload.entity);

        if(-1 !== index)
        {
            state.entitiesClosed.splice(index, 1);
        }
        else
        {
            state.entitiesClosed.push(payload.entity);
        }

        LocalStorage.set('schoolEntitiesClosed', state.entitiesClosed);
    },
    setSearch(state, payload)
    {
        state.search = payload.search;

        LocalStorage.set('schoolSearch', state.search);
    }
};

export default mutations;